import { getFirstDecisioningCreativeComponentVariant } from "./getFirstDecisioningCreativeComponentVariant";
import type {
  DecisioningCreativeComponentSelections,
  DecisioningCreativeComponentVariantsByComponent,
} from "./types";

/**
 * Builds default preview selections using the first non-empty variant per used component.
 *
 * @param usedComponents Component names discovered in the email.
 * @param variantsByComponent Variant lists keyed by component name.
 * @return Selection map defaulting each used component to its first variant.
 */
export const buildDefaultDecisioningCreativeComponentSelections = (
  usedComponents: string[],
  variantsByComponent: DecisioningCreativeComponentVariantsByComponent
): DecisioningCreativeComponentSelections => {
  return usedComponents.reduce<DecisioningCreativeComponentSelections>((selections, componentName) => {
    const firstCreative = getFirstDecisioningCreativeComponentVariant(variantsByComponent[componentName]);
    if (firstCreative.length > 0) {
      selections[componentName] = firstCreative;
    }
    return selections;
  }, {});
};
